/* eslint-disable no-use-before-define */

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { up, down } from 'slide-element';
import { createFocusTrap } from 'focus-trap';

import announcer from './aria-announcer';

let focusTrap;
let focusTrapTimeout;
let mobileMenuFocusTrap;
let mobileMenuTrapTimeout;

const $navMobile = document.querySelector('.nav-mobile');
const $navMobilePanel = document.querySelector('.nav-mobile-panel');
const $navMobileHeader = document.querySelector('.nav-mobile-header');
const $btnMobileMenu = document.querySelector('.mobile-menu-btn');
const $btnMenuItem = document.querySelectorAll('.nav-mobile-menu-btn');
const $btnSubmenuBack = document.querySelectorAll('.nav-mobile-submenu-back');
const $navMobileMenu = document.querySelector('#nav-mobile');
const $alertsContainer = document.querySelector('.alerts');
const $alerts = document.querySelectorAll('.alert');

const allAlertsDismissed = () => {
    if (!$alerts.length) return true;
    return [...$alerts].every(($alert) => $alert.style.display !== 'flex');
};

const hideAlerts = () => {
    if (!$alertsContainer) return;
    up($alertsContainer);
};

const showAlerts = () => {
    if (!$alertsContainer || allAlertsDismissed()) return;
    down($alertsContainer);
};

function onEscapeMobileMenu(event) {
    if (event.key !== 'Escape') return;
    if (document.querySelector('.main-nav-mobile-submenu.open')) return;

    $btnMobileMenu.click();
}

function onEscape(event) {
    if (event.key !== 'Escape') return;

    $btnMenuItem.forEach((btnMenuItem) => {
        if (btnMenuItem.getAttribute('aria-expanded') === 'true') {
            closeSubmenu(btnMenuItem);
        }
    });
}

function openSubmenu(btnMenuItem) {
    // Évite d'avoir plusieurs focus trap si le clic est répété
    if (btnMenuItem.getAttribute('aria-expanded') === 'true') return;

    const $currentSubmenu = btnMenuItem.nextElementSibling;

    $currentSubmenu.inert = false;
    btnMenuItem.setAttribute('aria-expanded', 'true');
    $currentSubmenu.setAttribute('aria-hidden', 'false');
    $currentSubmenu.classList.add('open');
    announcer.announce(`Le sous-menu ${btnMenuItem.textContent} est ouvert`);

    focusTrapTimeout = setTimeout(() => {
        focusTrap = createFocusTrap($currentSubmenu, {
            preventScroll: true,
            returnFocusOnDeactivate: false,
        });
        focusTrap.activate();
    }, 100);

    window.addEventListener('keydown', onEscape);
}

function closeSubmenu(btnMenuItem, restoreFocus = true) {
    const $currentSubmenu = btnMenuItem.nextElementSibling;
    const $btnBack = $currentSubmenu.querySelector('.nav-mobile-submenu-back');

    $currentSubmenu.inert = true;
    btnMenuItem.setAttribute('aria-expanded', 'false');
    $currentSubmenu.setAttribute('aria-hidden', 'true');
    $currentSubmenu.classList.remove('open');
    announcer.announce(`Le sous-menu ${$btnBack.textContent} est fermé`);

    clearTimeout(focusTrapTimeout);

    if (focusTrap) {
        focusTrap.deactivate();
        focusTrap = null;
    }

    if (restoreFocus) {
        btnMenuItem.focus();
    }

    window.removeEventListener('keydown', onEscape);
}

$btnMobileMenu.addEventListener('click', () => {
    $btnMobileMenu.classList.toggle('open');
    $navMobilePanel.classList.toggle('open');
    $navMobileHeader.classList.toggle('open');

    const isMenuOpen = $btnMobileMenu.classList.contains('open');

    if (isMenuOpen) {
        $btnMobileMenu.setAttribute('aria-expanded', 'true');
        announcer.announce('Le menu mobile est ouvert');
        disableBodyScroll($navMobileMenu, {
            allowTouchMove: (el) => el.closest('.nav-mobile-panel') !== null,
        });
        hideAlerts();

        mobileMenuTrapTimeout = setTimeout(() => {
            mobileMenuFocusTrap = createFocusTrap($navMobile, {
                preventScroll: true,
                returnFocusOnDeactivate: false,
            });
            mobileMenuFocusTrap.activate();
        }, 100);

        window.addEventListener('keydown', onEscapeMobileMenu);
    } else {
        $btnMobileMenu.setAttribute('aria-expanded', 'false');
        announcer.announce('Le menu mobile est fermé');
        enableBodyScroll($navMobileMenu);
        showAlerts();

        $btnMenuItem.forEach((btnMenuItem) => {
            if (btnMenuItem.getAttribute('aria-expanded') === 'true') {
                closeSubmenu(btnMenuItem, false);
            }
        });

        clearTimeout(mobileMenuTrapTimeout);

        if (mobileMenuFocusTrap) {
            mobileMenuFocusTrap.deactivate();
            mobileMenuFocusTrap = null;
        }

        window.removeEventListener('keydown', onEscapeMobileMenu);

        $btnMobileMenu.focus();
    }
});

$btnMenuItem.forEach((btnMenuItem) => {
    const $currentSubmenu = btnMenuItem.nextElementSibling;

    $currentSubmenu.inert = true;

    btnMenuItem.addEventListener('click', () => {
        openSubmenu(btnMenuItem);
    });
});

$btnSubmenuBack.forEach((btnSubmenuBack) => {
    btnSubmenuBack.addEventListener('click', () => {
        closeSubmenu(btnSubmenuBack.closest('.main-nav-mobile-submenu').previousElementSibling);
    });
});
